import {
  Button,
  Card,
  Form,
  FormLayout,
  Frame,
  Page,
  TextField,
} from "@shopify/polaris";
import React, { ReactElement } from "react";
import { isShopDomainValid } from "utils";

export default function Install(): ReactElement {
  const [value, setValue] = React.useState("");
  const [isErrorTextField, setIsErrorTextField] = React.useState<boolean>();

  const handleSubmit = () => {
    if (!isShopDomainValid(value)) {
      setIsErrorTextField(true);
    } else {
      window.location.href = `/api/auth?shop=${value}`;
    }
  };

  const handleChange = (newValue: string) => setValue(newValue);

  return (
    <Frame>
      <Page title={"Install Trust Badges Pro"}>
        <Card sectioned>
          <Form onSubmit={handleSubmit}>
            <FormLayout>
              <TextField
                error={isErrorTextField && "Store name is required"}
                value={value}
                placeholder="example.myshopify.com"
                label="Store name"
                onChange={handleChange}
                helpText="We'll use the store address to redirect you to install the app"
              />
              <Button primary submit>
                Install
              </Button>
            </FormLayout>
          </Form>
        </Card>
      </Page>
    </Frame>
  );
}
